import { useApiData } from "../../contexts/ApiData";
import Section from "../Section";
import { Card } from "../../types";
import { useEffect, useState } from "react";
import FeedbachCard from "./JourneyCardView";
import { useTranslations } from "../../contexts/Translation";
import { useNavigate } from "react-router-dom";
import SystemMessage from "../SystemMessage/Index";
import { InfoMessage } from "../InfoMessage/InfoMessage";
import { useProfile } from "../../contexts/UserProvider";
import CreateLink from "../CreateLink/CreateLink";
import styles from "./RouteHandler.module.css";

const CardRouteHandler = ({ isShared = false }) => {
  const { get } = useApiData();
  const t = useTranslations("cardForm");
  const [cards, setCards] = useState<Card[]>([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [loadFailed, setLoadFailed] = useState<boolean>(false);
  const profile = useProfile();

  useEffect(() => {
    const call = async () => {
      // get returns false when the request fails, so an empty list is only shown when it really is empty
      const cards = await get(isShared ? `/shared-card` : `/card`);
      if (Array.isArray(cards)) {
        setCards(cards);
      } else {
        setLoadFailed(true);
      }
      setIsLoading(false);
    };
    call();
  }, [get, isShared]);

  if (isLoading) {
    return <SystemMessage message='loading' />;
  }

  if (loadFailed) {
    return (
      <Section>
        <InfoMessage>
          <span role='alert'>{t("loadCardsError")}</span>
        </InfoMessage>
      </Section>
    );
  }

  return (
    <Section>
      {!isShared &&
        (!profile?.hasValidSubscription && cards.length > 0 ? (
          <InfoMessage>{t("onlyOneCard")}</InfoMessage>
        ) : (
          <CreateLink createFn={() => navigate(`/card`)} text={t("createCard")} />
        ))}
      {cards.length === 0 && <InfoMessage>{t(isShared ? "noSharedCards" : "noCards")}</InfoMessage>}
      <div className={styles.cardList}>
        {cards.map((c) => (
          <FeedbachCard key={c.cardId} card={c} refreshImage={!isShared} showVisits={!isShared} />
        ))}
      </div>
    </Section>
  );
};

export default CardRouteHandler;
